'use strict';

/**
 * Module dependencies
 */
var angular = require('angular');

module.exports = angular
  .module('app.core-components-implementation.popover', [])
  .config(require('./PopoverServiceImpl.js'))
;


// WEBPACK FOOTER //
// ./src/js/core-components-implementation/popover/index.js